import './import';

export async function importPlaces(): Promise<google.maps.PlacesLibrary> {
  const library = await window.google.maps.importLibrary('places');
  if (!library) {
    throw new Error('Google Places API not found');
  }
  return library as google.maps.PlacesLibrary;
}
